package org.catharsis.spendtel.feature.presentation.support

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import org.catharsis.spendtel.feature.presentation.web.WebContactSupportScreen

@Composable
actual fun ContactSupportScreen(
    navHostController: NavHostController,
    defaultName: String?,
    defaultEmail: String?,
) {
    WebContactSupportScreen(
        navHostController = navHostController,
        defaultName = defaultName,
        defaultEmail = defaultEmail,
    )
}
